import React from "react";

export default function Loader (props) {
  return (
    <div className="loader" style={props.withMargins ? { marginTop: "5%" } : props.style || {}}>
      <p></p>
    </div>
  );
}
